/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetLivestockAttentionQueryResponse, GetLivestockAttentionPathParams, GetLivestockAttentionQueryParams, GetLivestockAttention400, GetLivestockAttention401, GetLivestockAttention403, GetLivestockAttention404, GetLivestockAttention409, GetLivestockAttention500 } from "../../types/livestockController/GetLivestockAttention.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetLivestockAttentionUrl(organizationId: GetLivestockAttentionPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/livestock-attention` as const }
  return res
}

/**
 * @summary Computed 'needs attention' alerts (vaccination due, weighing overdue, paddock overstay, over capacity, calving window)
 * {@link /api/organizations/:organizationId/livestock-attention}
 */
export async function getLivestockAttention(organizationId: GetLivestockAttentionPathParams["organizationId"], params?: GetLivestockAttentionQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetLivestockAttentionQueryResponse, ResponseErrorConfig<GetLivestockAttention400 | GetLivestockAttention401 | GetLivestockAttention403 | GetLivestockAttention404 | GetLivestockAttention409 | GetLivestockAttention500>, unknown>({ method : "GET", url : getGetLivestockAttentionUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}